// A2P 10DLC opt-in configuration.
//
// Carriers vet the consent language a customer actually sees against the
// registered brand, so every value here has to match the campaign submission
// character for character. A display name that differs from the registered
// legal business name is what Twilio error 30927 ("opt-in evidence is for a
// different company") flags on review.
//
// Scoped to the venues currently registered for A2P messaging. This is
// deliberately a hardcoded allowlist rather than a settings lookup: the
// booking-site settings response exposes `sms_active`, which only becomes true
// AFTER activation, which requires an approved campaign, which requires the
// consent checkbox to already be publicly visible. Gating on `sms_active`
// therefore deadlocks. When more venues onboard, replace this with a
// `registration_status` check from booking site settings, which is true from
// campaign registration onward.

const VENUES = {
  otc: {
    // Registered legal business name on the carrier brand. Verify against
    // Trust Hub before changing.
    businessName: 'Off the Couch',
    privacyUrl: 'https://www.offthecouchgames.com/privacy-policy.html',
    termsUrl: 'https://www.offthecouchgames.com/terms-of-service.html',
  },
  // Test only. Mirrors the otc entry because the demo site belongs to the same
  // business, so the consent wording still names the entity that would actually
  // be sending. Remove this once the registration_status gate replaces the map:
  // a demo site is not a registered sender, and consent collected here is not
  // consent anyone should act on.
  demo: {
    businessName: 'Off the Couch',
    privacyUrl: 'https://www.offthecouchgames.com/privacy-policy.html',
    termsUrl: 'https://www.offthecouchgames.com/terms-of-service.html',
  },
};

// Platform named alongside the venue in the consent wording. Keeping both
// parties in the language means consent stays valid if sending ever moves to a
// platform-owned number, instead of having to be re-collected.
export const SMS_PLATFORM_NAME = 'Off the Couch';

export function getSmsConsentVenue(companyCode) {
  if (!companyCode) return null;
  return VENUES[companyCode] || null;
}

export function isSmsConsentVenue(companyCode) {
  return getSmsConsentVenue(companyCode) !== null;
}
